import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../../api/axios";

const ApprovalAction = ({ approvalLines = [] }) => {
  const { docId: documentId } = useParams();
  const userId = JSON.parse(localStorage.getItem("user") || "{}")?.id;

  const [approvalComment, setApprovalComment] = useState("");
  const [currentUserApproval, setCurrentUserApproval] = useState(null);

  /* =========================
     결재 처리
  ========================= */
  const handleApproval = async (action) => {
    if (action === "rejected" && !approvalComment.trim()) {
      alert("반려 시에는 의견을 입력해주세요.");
      return;
    }

    try {
      await axios.patch(
        `approval/action/${currentUserApproval.id}/`,
        {
          action,
          comment: approvalComment,
        }
      );
      alert(action === "approved" ? "승인되었습니다." : "반려되었습니다.");
      window.location.reload();
    } catch (error) {
      console.error("결재 처리 실패:", error);
      alert("결재 처리 중 오류가 발생했습니다.");
    }
  };

  /* =========================
     내 결재 차례 판단
  ========================= */
  useEffect(() => {
    if (!approvalLines?.length) return;

    const submitOrders = approvalLines
      .filter((l) => l.is_approved === "submit")
      .map((l) => l.order);

    if (!submitOrders.length) return;

    const minOrder = Math.min(...submitOrders);

    const myLine = approvalLines.find(
      (l) => Number(l.approver_id) === Number(userId)
    );

    if (
      myLine &&
      myLine.is_approved === "submit" &&
      myLine.order === minOrder
    ) {
      setCurrentUserApproval(myLine);
    }
  }, [approvalLines, userId]);

  const histories = approvalLines.filter((h) => h.approved_at);

  return (
    <div className="space-y-4 text-sm">
      {/* ================= 결재 처리 ================= */}
      {currentUserApproval && (
        <div className="border-2 border-gray-200 rounded-lg p-4 bg-white">
          <div className="mb-3">
            <h4 className="text-sm font-bold text-gray-800">
              결재 처리
            </h4>
            <p className="text-xs text-gray-600 mt-1">
              승인 또는 반려를 선택하고 의견을 입력해주세요.
            </p>
          </div>

          <textarea
            value={approvalComment}
            onChange={(e) => setApprovalComment(e.target.value)}
            rows={4}
            className="w-full border-2 border-gray-300 rounded-lg p-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
            placeholder="결재 의견을 입력하세요 (반려 시 필수)"
          />

          <div className="mt-3 flex gap-2">
            <button
              onClick={() => handleApproval("approved")}
              className="flex-1 btn-save-sm"
            >
              승인
            </button>
            <button
              onClick={() => handleApproval("rejected")}
              className="flex-1 btn-delete-sm"
            >
              반려
            </button>
          </div>

          <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-xs text-red-800">
              ⚠ 반려 시 의견 입력은 필수입니다
            </p>
          </div>
        </div>
      )}

      {/* ================= 결재 이력 ================= */}
      <div className="border rounded p-3 bg-white">
        {histories.length === 0 ? (
          <div className="text-xs text-gray-500">
            아직 결재 이력이 없습니다.
          </div>
        ) : (
          <div className="space-y-2">
            {histories.map((h) => (
              <div
                key={h.id}
                className={`border-l-4 p-2 text-xs ${h.is_approved === "approved"
                  ? "border-green-500 bg-green-50"
                  : "border-red-500 bg-red-50"
                  }`}
              >
                <div className="flex justify-between">
                  <div>
                    <div className="font-semibold">
                      {h.approver_name}
                      {h.approver_position
                        ? ` (${h.approver_position})`
                        : ""}
                    </div>
                    <div
                      className={
                        h.is_approved === "approved"
                          ? "text-green-700"
                          : "text-red-700"
                      }
                    >
                      {h.is_approved === "approved" ? "승인" : "반려"}
                    </div>
                    {h.comment && (
                      <div className="mt-1 text-gray-700">
                        “{h.comment}”
                      </div>
                    )}
                  </div>
                  <div className="text-gray-500 whitespace-nowrap">
                    {new Date(h.approved_at).toLocaleString("ko-KR")}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApprovalAction;
